"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _echarts = _interopRequireDefault(require("echarts"));
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('echarts/theme/macarons'); // echarts theme
var _default = exports.default = {
  components: {
    CountTo: _vueCountTo.default
  },
  props: {
    title: {
      type: String,
      default: '数据统计'
    },
    showEquip: {
      type: Boolean,
      default: true
    },
    platList: {
      type: Array,
      default: []
    }
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.getters.deviceNameObj;
    }
  },
  data: function data() {
    return {
      device_type: -1,
      colorPalette: (0, _index.colorPalette)(),
      son_list: [],
      search_agent_id: '0',
      drop_title: '全部品牌',
      chartColumn: null,
      chartColumnData: {
        value: 24.2,
        text: '-',
        color: ['#a38cd2', '#27b5db', '#e9a601', '#4bdc7e', '#7a75e9'],
        xAxis: ['充电宝', '充电线', '充电桩', '套套机'],
        // values:['76','78','22','30','50'],
        values: [],
        graphicValue: ['7元', '8元', '9元', '10元', '其他']
      },
      seriesData: [],
      titleData: [],
      graphic: [],
      // 充电宝
      bao_num: 0,
      bao_num_online: 0,
      bao_num_offline: 0,
      bao_num_outlet_total: 0,
      bao_num_outlet_free: 0,
      bao_num_outlet_using: 0,
      // 充电线
      thread_num: 0,
      thread_num_bind: 0,
      thread_num_unbind: 0,
      thread_num_recycle: 0,
      // 充电桩
      zhuang_num: 0,
      zhuang_num_online: 0,
      zhuang_num_offline: 0,
      zhuang_num_outlet: 0,
      zhuang_num_using: 0,
      zhuang_num_unusing: 0,
      // 套套机
      wash_num: 0,
      wash_num_bind: 0,
      wash_num_unbind: 0,
      wash_num_recycle: 0,
      // 使用率切换标签
      percentType: 'lastDay',
      // 添加加载状态
      chartLoading: true
    };
  },
  mounted: function mounted() {
    this.handleDeviceData();
    this.getEquipData();
  },
  methods: {
    /**
     * 使用率切换
     * @param value
     */
    handleChange: function handleChange(value) {
      this.percentType = value;
      this.getEquipData();
      this.handleDeviceData();
    },
    /**
     * 获取运营数据
     * 获取饼状图数据
     */
    getEquipData: function getEquipData() {
      var _this = this;
      this.chartLoading = true; // 开始加载

      // 销毁已有的实例
      if (this.chartColumn) {
        this.chartColumn.dispose();
        this.chartColumn = null; // 重置引用
      }
      this.chartColumnData.values = [];
      // 清空标题数据
      this.titleData = [];
      // 清空系列数据
      this.seriesData = [];
      // 清空图形数据
      this.graphic = [];

      // 获取设备的使用率
      this.$get('agentapi/data_overview/overview_device_use_ratio', {
        search_agent_id: this.search_agent_id,
        period: this.percentType
      }).then(function (res) {
        _this.chartColumnData.values.push((res.bao_list_use_rate * 100).toFixed(1));
        _this.chartColumnData.values.push((res.line_list_use_rate * 100).toFixed(1));
        _this.chartColumnData.values.push((res.pile_list_use_rate * 100).toFixed(1));
        _this.chartColumnData.values.push((res.suit_list_use_rate * 100).toFixed(1));
        _this.chartLoading = false;
        _this.$nextTick(function () {
          console.log('开始绘制图表');
          _this.drawPieChart();
        });
      });
    },
    // 获取设备数据
    handleDeviceData: function handleDeviceData() {
      var _this2 = this;
      // 获取设备在线、绑定、离线等数据
      this.$get('agentapi/my_type_device_data', {
        device_type: this.device_type,
        search_agent_id: this.search_agent_id,
        period: this.percentType
      }).then(function (res) {
        // 充电宝
        _this2.bao_num = res.bao_num;
        _this2.bao_num_online = res.bao_num_online;
        _this2.bao_num_offline = res.bao_num_offline;
        _this2.bao_num_outlet_total = res.bao_num_outlet_total;
        _this2.bao_num_outlet_free = res.bao_num_outlet_free;
        _this2.bao_num_outlet_using = res.bao_num_outlet_using;
        // 充电线
        _this2.thread_num = res.thread_num;
        _this2.thread_num_bind = res.thread_num_bind;
        _this2.thread_num_unbind = res.thread_num_unbind;
        _this2.thread_num_recycle = res.thread_num_recycle;
        // 充电桩
        _this2.zhuang_num = res.zhuang_num;
        _this2.zhuang_num_online = res.zhuang_num_online;
        _this2.zhuang_num_offline = res.zhuang_num_offline;
        _this2.zhuang_num_outlet = res.zhuang_num_outlet;
        _this2.zhuang_num_using = res.zhuang_num_using;
        _this2.zhuang_num_unusing = res.zhuang_num_unusing;
        // 套套机
        _this2.wash_num = res.wash_num;
        _this2.wash_num_bind = res.wash_num_bind;
        _this2.wash_num_unbind = res.wash_num_unbind;
        _this2.wash_num_recycle = res.wash_num_recycle;
        // 绘制图表
        _this2.$nextTick(function () {
          _this2.drawPieChart();
        });
      });
    },
    // 绘制饼状图
    drawPieChart: function drawPieChart() {
      // 检查 DOM 元素是否存在
      var chartElement = document.getElementById('chartColumn');
      if (!chartElement) {
        console.warn('Chart element not found');
      }
      this.chartColumn = _echarts.default.init(chartElement);
      this.setSeriesData();
      this.chartColumn.setOption({
        // tooltip: {
        //   trigger: 'item'
        // },
        // legend: {
        //   top: '5%',
        //   left: 'center'
        // },
        title: this.titleData,
        series: this.seriesData
        //graphic:this.graphic,
      });
    },
    // 设置系列数据
    setSeriesData: function setSeriesData() {
      var that = this;
      that.chartColumnData.values.forEach(function (item, index) {
        var centerXv = [12, 19, 21, 22][index];
        var centerX = centerXv * (index + 1) + '%';
        that.titleData.push({
          text: that.chartColumnData.xAxis[index],
          left: centerX,
          top: '75%',
          // 调整到饼图下方合适位置
          textAlign: 'center',
          textStyle: {
            fontSize: '12',
            color: '#687284',
            fontWeight: '400'
          }
        });
        // 优化饼图位置和大小
        that.seriesData.push({
          type: 'pie',
          radius: ['30', '40'],
          center: [centerX, '45%'],
          // 垂直居中
          hoverAnimation: false,
          label: {
            normal: {
              position: 'center'
            }
          },
          data: [{
            value: item,
            name: that.chartColumnData.text,
            itemStyle: {
              normal: {
                color: that.chartColumnData.color[index]
              }
            },
            label: {
              normal: {
                show: false
              }
            }
          }, {
            value: 100 - item,
            name: '占位',
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: '#f8f8f8'
              }
            },
            label: {
              normal: {
                formatter: item + '%',
                textStyle: {
                  fontSize: 15,
                  color: that.chartColumnData.color[index],
                  fontWeight: 'bold' // 加粗百分比数字
                }
              }
            }
          }]
        });
        // 优化图形元素居中
        that.graphic.push({
          type: 'circle',
          left: centerX,
          // 居中对齐
          top: '15%',
          shape: {
            r: 20 // 圆形半径
          },
          style: {
            fill: that.chartColumnData.color[index],
            // 使用对应的颜色
            text: that.chartColumnData.graphicValue[index],
            textAlign: 'center',
            textVerticalAlign: 'middle',
            // 垂直居中
            fontSize: 12
          }
        });
      });
    },
    // 切换设备类型
    switchType: function switchType(type) {
      this.device_type = type;
      this.$emit('switchType', type);
    },
    // 切换平台
    drop: function drop(v, n) {
      this.drop_title = n;
      this.$emit('switchPlat', v);
    },
    // 销毁图表
    beforeDestroy: function beforeDestroy() {
      if (this.chartColumn) {
        this.chartColumn.dispose();
        this.chartColumn = null;
      }
    }
  }
};